import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { productShortName } from '../data/offer';
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const show = window.setTimeout(() => setVisible(true), 5000);
    const hide = window.setTimeout(() => setVisible(false), 15000);
    return () => {
      window.clearTimeout(show);
      window.clearTimeout(hide);
    };
  }, []);
  return <AnimatePresence data-id="element-203" data-mp="21ydbohrq2ixm">
      {visible && <motion.aside initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 14
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-4 right-4 z-50 w-[calc(100%-2rem)] max-w-sm rounded-lg border border-line border-l-4 border-l-sage bg-panel p-4 pr-10 text-ink shadow-lift" aria-live="polite" data-id="element-204" data-mp="1wxxvlig22xby">
          <button type="button" onClick={() => setVisible(false)} className="absolute right-2 top-2 rounded p-1 text-muted transition-colors duration-150 ease-out hover:text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" aria-label="Dismiss notice" data-id="element-205" data-mp="1sh7moy5u265p">
            <XIcon className="h-4 w-4" data-id="element-206" data-mp="1niwa4fo5lhjs" />
          </button>
          <div className="flex gap-3" data-id="element-207" data-mp="19odfiqegbic1">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-sage" aria-hidden="true" data-id="element-208" data-mp="19nbt5przj9f0" />
            <div data-id="element-209" data-mp="1ei7ytsq59val">
              <p className="text-[10px] font-extrabold uppercase tracking-[.16em] text-forestSoft" data-id="element-210" data-mp="zr8tcqklvmv8">Access confirmed</p>
              <p className="mt-1 text-sm leading-snug" data-id="element-211" data-mp="14psguveul6pp">
                When you complete your purchase you receive the
                <br data-id="element-212" data-mp="qrlply4em4z0" />
                <span className="font-bold text-forestSoft" data-id="element-213" data-mp="qr2fh3kzwkvj">{productShortName}</span>
              </p>
              <p className="mt-2 text-xs text-muted" data-id="element-214" data-mp="vou85ztgsb0s">Instant digital access by email</p>
            </div>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}